module.exports = __webpack_public_path__ + "static/img/1.c0b66a1e.webp";